<div class="modal-header row">
  <div class="modal-header-content">
      <h1 class="modal-title">{{'Manage taxonomies - ' + templateName}}</h1>
    <h2 class="modal-subtitle">Change file taxonomies according to your input files.</h2>
  </div>
  <i class="ic-close icon-size-32" (click)="activeModal.close()"></i>
  <div class="key-sets-wrapper" *ngIf="keysLoaded">
    <div class="tabs-wrapper">
      <div class="tabs-container">
        <a *ngFor='let key of keys; let i = index'
          (click)='getSelected(key, i);'
          class="btn single-tab {{i === activeIndexTab ? 'active border-' + execution?.name_tool : '' }}">
          {{key}}
        </a>
      </div>
    </div>
  </div>
</div>
<div class="modal-body form-container" #modalBody>
  <ng-container *ngIf='selectedKey !== undefined'>
    <div *ngFor="let fileSection of templateTaxonomyInfo.file_categories_tab[selectedKey].toolTable">
      <app-table *ngIf='fileSection'
        [data]="fileSection"
        [info]="section"
        [isSimpleTable]="true"
        [auto]="true"
        class="customTableTaxonomies"
        (sendTaxonomyChanged)="setTaxonomyChanged($event)"
        key='manage_taxonomies_modal'>
      </app-table>
    </div>
  </ng-container>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close()">Cancel</button>
  <button
    class="btn btn-default ml-3"
    type='submit'
    (click)='onSave()'>
    Apply
  </button>
</div>
